import { gridSizeMdLg6 } from '@/shared';
import { CustomTextField } from '@/shared/components/ui';
import { ActivacionInstaOTActiDataFormTabProps } from './../ActivacionInstaOTActiDataFormTab';

export type FlotaAndServiceActivationInstallPartProps =
  ActivacionInstaOTActiDataFormTabProps & {};

const FlotaAndServiceActivationInstallPart: React.FC<
  FlotaAndServiceActivationInstallPartProps
> = ({ form }) => {
  const { errors } = form?.formState || {};
  const shrink = true;

  return (
    <>
      <>
        <CustomTextField
          name="flotaLabel"
          label="Flota"
          control={form.control}
          defaultValue={form.getValues().flotaLabel || ''}
          error={errors.flotaLabel}
          helperText={errors.flotaLabel?.message || ''}
          disabled
        />
        <CustomTextField
          label="Tipo Orden de Trabajo"
          name="tipo_orden_trabajo"
          control={form.control}
          defaultValue={form.getValues().tipo_orden_trabajo || ''}
          error={errors.tipo_orden_trabajo}
          helperText={errors.tipo_orden_trabajo?.message}
          shrink={shrink}
          disabled
        />

        <CustomTextField
          label="Número de documento"
          name="numero_documento"
          control={form.control}
          defaultValue={form.getValues().numero_documento || ''}
          error={errors.numero_documento}
          helperText={errors.numero_documento?.message}
          disabled
        />
        <CustomTextField
          name="tipo_servicio"
          label="Tipo de Servicio"
          control={form.control}
          defaultValue={form.getValues().tipo_servicio || ''}
          error={errors.tipo_servicio as any}
          helperText={errors.tipo_servicio?.message as any}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="planLabel"
          label="Plan Internet"
          control={form.control}
          defaultValue={form.getValues().planLabel || ''}
          error={errors.planLabel as any}
          helperText={errors.planLabel?.message as any}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="velocidad_internet"
          label="Velocidad Internet"
          control={form.control}
          defaultValue={form.getValues().velocidad_internet || ''}
          error={errors.velocidad_internet as any}
          helperText={errors.velocidad_internet?.message as any}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="tipo_instalacion"
          label="Tipo de Instalación"
          control={form.control}
          defaultValue={form.getValues().tipo_instalacion || ''}
          error={errors.tipo_instalacion as any}
          helperText={errors.tipo_instalacion?.message as any}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
      </>
    </>
  );
};

export default FlotaAndServiceActivationInstallPart;
